/**
 * Checks if the current environment is a Static Site Generator (SSG).
 */
export const isSSG = () => navigator.webdriver;
